import React from 'react';


const ToDoList = (props)=>{

    let listItems = props.list.map((item,index)=>{
        return <li className="listItem" key={index}> 
                    <div>
                        <button
                        className="deleteBtn"   
                        onClick={()=>{
                            props.delete(index);
                        }}
                        >-</button> 
                    </div>
                    
                    <div>
                        <p className="item">{item}</p>

                    </div>
                </li>
    })

    return (
            
            <ul className="listContainer">{listItems}</ul>
        );

}


export default ToDoList;